import { render } from "./NewOrderDetail.vue?vue&type=template&id=1fa2a202&scoped=true"
import script from "./NewOrderDetail.vue?vue&type=script&lang=js"
export * from "./NewOrderDetail.vue?vue&type=script&lang=js"

import "./NewOrderDetail.vue?vue&type=style&index=0&id=1fa2a202&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fa2a202"]])

export default __exports__